import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '@/lib/route-guards';
import { warm, warmBackground } from '@/api/loaders';
import { campaignsList, eventsList, productionsList, venuesList } from '@/api/resources';
import { VENUES_SCREEN_EVENT_RANGE, eventsRangeQuery } from '@/lib/event-ranges';
import { useSetViewShim } from '@/lib/use-set-view';
import { VenuesView } from '@/screens/venues';

export const Route = createFileRoute('/backend/venues')({
  validateSearch: (s: Record<string, unknown>): { focus?: string } => ({
    focus: typeof s.focus === 'string' ? s.focus : undefined,
  }),
  beforeLoad: requireSession,
  // Block only on the rows this screen is ABOUT; warm its companions in the
  // background. Awaiting everything would trade one problem for another —
  // no empty flash, but a cold load that shows the previous route until the
  // slowest query lands. The table renders its own loading state for
  // whatever is still in flight.
  loader: ({ context }) => {
    // Same window the performance panel reads — see the note in backend/events.tsx.
    warmBackground(
      context.queryClient,
      productionsList({}),
      campaignsList({}),
      eventsList(eventsRangeQuery(VENUES_SCREEN_EVENT_RANGE)),
    );
    return warm(context.queryClient, venuesList({}));
  },
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  const { focus } = Route.useSearch();
  return <VenuesView setView={setView} focus={focus} />;
}
